'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _connectionsConstants = require('../connectionsConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.Map();

/**
 * Stores a map of connection sources and the target IDs of the things they're connected to.
 */


// Constants

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _connectionsConstants.CONNECTIONS_SET:
            return state.set(action.id, Immutable.fromJS(action.connections));
        case _connectionsConstants.CONNECTIONS_REMOVE:
            return state.delete(action.id);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/reducers/connectionsReducer.js
// module id = 1712
// module chunks = 0